import { Wrench, Clock } from 'lucide-react';

export default function MaintenancePage({ settings }) {
  const title = settings?.maintenance_title || 'Sito temporaneamente in manutenzione';
  const message = settings?.maintenance_message || 'Stiamo effettuando alcuni aggiornamenti. Torneremo disponibili al più presto.';
  const returnTime = settings?.maintenance_return_time;

  return (
    <div className="min-h-screen bg-[#F9F7F2] flex items-center justify-center px-6">
      <div className="w-full max-w-xl bg-white rounded-3xl shadow-xl border border-gray-200 p-8 text-center">
        <div className="w-20 h-20 mx-auto rounded-full bg-[#5D1822]/10 flex items-center justify-center mb-6">
          <Wrench className="w-10 h-10 text-[#5D1822]" />
        </div>
        <h1 className="text-3xl font-bold text-[#5D1822] mb-4">{title}</h1>
        <p className="text-gray-600 text-lg leading-relaxed">{message}</p>
        {returnTime && (
          <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#C5A059]/15 px-4 py-2 text-[#5D1822] font-semibold">
            <Clock className="w-5 h-5" />
            Ritorno previsto: {returnTime}
          </div>
        )}
        <p className="mt-8 text-sm text-gray-400">Macelleria Borgese</p>
      </div>
    </div>
  );
}
